import React from 'react';
import PropTypes from 'prop-types';
//import CountUp from 'react-countup';
import Box from 'common/components/Box';
import Image from 'common/components/Image';
import Card from 'common/components/Card';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Button from 'common/components/Button';
import FeatureBlock from 'common/components/FeatureBlock';
import Container from 'common/components/UI/Container';
import WorkHistoryWrapper, { CounterUpArea } from './workHistory.style';
import shape1 from 'common/assets/image/cryptoModern/salesforce.png';
import shape2 from 'common/assets/image/cryptoModern/google.png';
import shape3 from 'common/assets/image/cryptoModern/slack.png';
import shape4 from 'common/assets/image/cryptoModern/snowflake2.png';

const WorkHistory = ({ row, col, cardStyle, btnStyle }) => {
  return (
    <WorkHistoryWrapper id="workHistorySection">
      <Container>
        <Box className="column-reverse row" {...row}>
          <Box className="container-wrapper col" {...col}>
            <CounterUpArea>
              <Card className="card" {...cardStyle}>
                <Image src={shape1} alt="Salesforce" />
                <h3>
                  {/*<CountUp start={0} end={75000} />+*/}
                 Salesforce
                </h3>
                {/*<Text content="Lorem Ipsum" />*/}
              </Card>
              <Card className="card" {...cardStyle}>
                <Image src={shape2} alt="Google" />
                <h3>
                   {/*<CountUp start={0} end={80} duration={5} />*/}
                   Google
                </h3>
                {/*<Text content="Lorem Ipsum" />*/}
              </Card>
              <Card className="card" {...cardStyle}>
                <Image src={shape3} alt="Slack" />
                <h3>
                  {/*<CountUp start={0} end={9350} duration={5} />+*/}
                  Slack
                </h3>
                {/*<Text content="Lorem Ipsum" />*/}
              </Card>
              <Card className="card" {...cardStyle}>
                <Image src={shape4} alt="Snowflake" />
                <h3>
                  {/*<CountUp start={0} end={30000} duration={5} />+*/}
                  Snowflake
                </h3>
                {/*<Text content="Lorem Ipsum" />*/}
              </Card>
            </CounterUpArea>
          </Box>
          <Box className="container-wrapper col" {...col}>
            <FeatureBlock
              title={<Heading content="Agentic Tools - AI Agents Tailored for Every Sector" />}
              description={
                <Text content="Meet the leading platform for Agentic Process Automation.
" />
              }
              /*button={
                <Button
                  title="Explore Industry Solutions"
                  variant="textButton"
                  icon={<i className="flaticon-next" />}
                  {...btnStyle}
                />
              }*/
            />
          </Box>
        </Box>
      </Container>
    </WorkHistoryWrapper>
  );
};

// WorkHistory style props
WorkHistory.propTypes = {
  sectionHeader: PropTypes.object,
  sectionTitle: PropTypes.object,
  sectionSubTitle: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  cardStyle: PropTypes.object,
};

// WorkHistory default style
WorkHistory.defaultProps = {
  // WorkHistory section row default style
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
  },
  // WorkHistory section col default style
  col: {
    pr: '15px',
    pl: '15px',
    width: [1, 1, 1 / 2, 1 / 2],
    flexBox: true,
    alignSelf: 'center',
  },
  // Card default style
  cardStyle: {
    p: ['20px 20px', '30px 20px', '30px 20px', '53px 40px'],
    borderRadius: '10px',
  },

  // Button default style
  btnStyle: {
    minWidth: '156px',
    fontSize: '14px',
    fontWeight: '500',
  },
};

export default WorkHistory;
